import { RootState, store } from '../../index';
import { IDLE_STATUS } from '../../../utils/types/statuses';

export const checkCanLoadCountries = (cb: () => void): void => {
  const { countries } = store.getState();
  if (countries.status === IDLE_STATUS) {
    cb();
  }
};

type TCountriesForSelectReturn = Array<{
  value: number;
  label: string;
  code: string;
}>;

export const getCountriesForSelect = (
  state: RootState,
): TCountriesForSelectReturn =>
  state.countries.data.map((country) => ({
    value: country.id,
    label: country.name,
    code: country.code,
  }));
